import Swal from 'sweetalert2'

import CONST_SOCKET from '../../const/socket'
import CONST_COMPONENT from '../../const/component'

const newPostbackOutputSequenceClass = CONST_SOCKET.NEW_POSTBACK_OUTPUT_SEQUENCE.toLowerCase()

export const hideNewPostbackNodeAndModalElementsIfConnectedWithSequenceSingle = (connection) => {
  const nodeInput = connection.input.node
  const nodeOutput = connection.output.node

  if ((CONST_COMPONENT.SEQUENCE_SINGLE === nodeOutput.name && 
    CONST_COMPONENT.POSTBACK_NEW === nodeInput.name) ||
    (CONST_COMPONENT.OTN_SINGLE === nodeOutput.name &&
    CONST_COMPONENT.POSTBACK_NEW === nodeInput.name)
  ) {
    // Hides socket
    toggleSocketElements(nodeInput, 'hide')

    // Hides elements on modal if it is open
    toggleModalElements(nodeInput, 'hide')
  }
}

export const showNewPostbackNodeAndModalElementsIfConnectedWithSequenceSingle = (connection) => {
  const nodeInput = connection.input.node
  const nodeOutput = connection.output.node

  if ((CONST_COMPONENT.SEQUENCE_SINGLE === nodeOutput.name && 
      CONST_COMPONENT.POSTBACK_NEW === nodeInput.name) ||
      (CONST_COMPONENT.OTN_SINGLE === nodeOutput.name &&
      CONST_COMPONENT.POSTBACK_NEW === nodeInput.name)
  ) {
    // Displays hidden socket
    toggleSocketElements(nodeInput, 'show')

    // Displays hidden elements on modal if it is open
    toggleModalElements(nodeInput, 'show')
  }
}

const toggleSocketElements = (node, showHide) => {
  if (Array.isArray(node.vueContext.$children)) {
    for (const child of node.vueContext.$children) {
      if (child.$el.classList.contains(newPostbackOutputSequenceClass)) {
        const parentElement = $(child.$el).parent()
        if ('show' === showHide) {
          parentElement.removeClass('d-none').addClass('d-block')
        } else if ('hide' === showHide) {
          parentElement.removeClass('d-block').addClass('d-none')
        }
      }
    }
  }
}

const toggleModalElements = (node, showHide) => {
  if (Swal.isVisible()) {  
    const nodeClass = '.node-id-' + node.id
    const parentElement = $(nodeClass).find('.new-postback-hidable-field').parent()

    if ('show' === showHide) {
      parentElement.removeClass('d-none').addClass('d-block')
    } else if ('hide' === showHide) {
      parentElement.removeClass('d-block').addClass('d-none')
    }
  }
}